import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import client from '../modules/axios';
import Tags from '../layout/Tags';
import { API } from '../config/path';
import { useApp } from '../context/appContext';
import { Helmet } from 'react-helmet-async';

const initPageSettings = {
  page: 1,
  search: null,
  category: null,
  region: null,
  totalPage: 0,
  total: 0,
  slug: null,
};

const App = () => {
  const { snackbar, setSnackbar } = useApp();
  const [searchParams] = useSearchParams();
  const [products, setProducts] = useState(null);
  const [pageSettings, setPageSettings] = useState(initPageSettings);
  const [isSearch, setIsSearch] = useState(false);
  const [isGetProducts, setIsGetProducts] = useState(true);
  const [meta, setMeta] = useState(null);

  const { slug } = useParams();

  // const getMeta = useCallback(() => {
  //   client
  //     .get(`${API.TAG_SEO}/${slug}`)
  //     .then((response) => {
  //       const data = response.data.data;

  //       setMeta(data);
  //     })
  //     .catch((_error) => {
  //       // Snackbar.error(error.statusText);
  //     });
  // }, []);

  // useLayoutEffect(() => {
  //   getMeta();
  // }, [getMeta]);

  useEffect(() => {
    if (!slug) return;

    // ✅ reset meta first
    setMeta(null);

    client
      .get(`${API.TAG_SEO}/${slug}`)
      .then((response) => {
        setMeta(response.data.data);
      })
      .catch(() => {
      });
  }, [slug]);

  useEffect(() => {
    if (searchParams.has('search')) {
      setPageSettings({
        ...pageSettings,
        search: searchParams.get('search'),
      });
    }
    if (searchParams.has('region')) {
      setPageSettings({
        ...pageSettings,
        region: searchParams.get('region'),
      });
    }
    setIsSearch(true);
  }, [searchParams.has('search'), searchParams.has('region')]);

  const getProducts = useCallback((payload)=>{
    client
      .get(`${API.PRODUCT_BY_TAG}/${slug}`)
      .then((res) => {
        if (res.data.error) {
          setProducts([]);
          setPageSettings({
            ...payload,
            totalPage: 1,
          });
          return;
        }

        const data = res.data.data;

        setProducts(data);
        setPageSettings((prev) => ({
          ...prev,
          totalPage: res.data.total_page,
          total: res.data.total,
          slug: slug
        }));
      })
      .catch(() => {
        setSnackbar({
          ...snackbar,
          open: true,
          message: 'Something went wrong',
          type: 'error',
        });
      })
      .finally(() => {
        setIsGetProducts(false);
      });
  }, [slug]);   // <= slug must be dependency


  useEffect(() => {
    if (isSearch) {
      setPageSettings({
        ...pageSettings,
        page: 1,
      });
      getProducts({...pageSettings,page:1});
      setIsSearch(false);
    }
  }, [isSearch, getProducts]);

  useEffect(() => {
    if (!slug) return;

    setIsGetProducts(true);
    getProducts({ ...pageSettings, page: 1 });

  }, [slug]);


  return (
    <>
      {meta && (
        <Helmet>
          <title>{meta.title ?? 'Indoaddict'}</title>
          <meta name="keyword" content={meta.keyword} />
          <meta name="description" content={meta.description} />

          {meta?.type.map((item, i) => {
            if (meta.value === 'title') {
              return <title key={i}>{item.content}</title>;
            }

            if (item.value === 'canonical') {
              return <link key={i} rel="canonical" href={item.content} />;
            }

            return <meta key={i} {...{ [item.tag_type]: item.value }} content={item.content} />;
          })}
        </Helmet>
      )}

      <Tags
        products={products}
        pageSettings={pageSettings}
        setPageSettings={(e)=>{
          getProducts(e)
          setPageSettings(e)
          window.scrollTo(0, 0);
        }}
        setIsSearch={setIsSearch}
        isGetProducts={isGetProducts}
      />
    </>
  );
};

export default App;
